import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

export default function WorkspaceLogo({ name, logoUrl, width = 96, height = 56 }) {
  const [imageFailed, setImageFailed] = useState(false);
  const initial = (name || "?").trim().charAt(0).toUpperCase();

  if (logoUrl && !imageFailed) {
    return (
      <Box
        component="img"
        alt=""
        src={logoUrl}
        onError={() => setImageFailed(true)}
        sx={{
          width,
          height,
          objectFit: "contain",
          objectPosition: "left center",
          display: "block",
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width,
        height,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        fontSize: height > 40 ? 28 : 18,
        fontWeight: 600,
        color: "#1967d2",
      }}
    >
      {initial}
    </Box>
  );
}

WorkspaceLogo.propTypes = {
  name: PropTypes.string,
  logoUrl: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
